const initialState = {
    login: null,
    firstName: null,
    lastName: null,
    isLoggedIn: false,
    checkedState: false,
    lastUpdated: null,
    role: null,
    permissions: [],
    club: null,
    clubs: []
};

export default function accountReducer(state = initialState, action = {type: ''}) {
    switch (action.type) {
        case 'SET_ACCOUNT': {
            if (!action.data) {
                return {
                    ...initialState,
                    checkedState: true
                };
            }
            return {
                ...state,
                ...action.data,
                isLoggedIn: !!action.data.id,
                checkedState: true
            };
        }
        case 'SET_ROLE': {
            if (action.role) {
                return {
                    ...state,
                    role: action.data
                };
            }
            break;
        }
        case 'SET_CLUBS': {
            if (action.data) {
                return {
                    ...state,
                    clubs: action.data
                };
            }
            break;
        }
    }
    return state;
}
